const Greeting = () => {
  return (
    <div className="greeting-container">
      <p className="greeting-text">Start typing to generate robots!</p>
    </div>
  );
};

export default Greeting;
